import {useState} from "react";
import {NewClickOverviewT} from "../OverviewModal/types";

export function useClickModalHelper() {
  const [isClickModalOpen, setIsClickModalOpen] = useState(false);
  const [newClickOverview, setNewClickOverview] = useState<NewClickOverviewT | undefined>();

  const closeModal = () => {
    setIsClickModalOpen(false);
    setNewClickOverview(undefined);
  };
  const openModal = (openNewClickOverview?: NewClickOverviewT | undefined) => {
    setIsClickModalOpen(true);
    if (openNewClickOverview != null) {
        setNewClickOverview(openNewClickOverview);
    }
  }
  return {
      isClickModalOpen,
      newClickOverview,
      openModal,
      closeModal
  };
}